import { render } from "./WorkStationTable.vue?vue&type=template&id=66b19f9a&scoped=true"
import script from "./WorkStationTable.vue?vue&type=script&lang=js"
export * from "./WorkStationTable.vue?vue&type=script&lang=js"

import "./WorkStationTable.vue?vue&type=style&index=0&id=66b19f9a&scoped=true&lang=css"

import exportComponent from "/home/runner/work/acp-portal-frontend/acp-portal-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-66b19f9a"]])

export default __exports__